import { styled } from 'linaria/react';
import { breakpoints } from 'common/styles/breakpoints';

export const AdditionalLinksContainer = styled.div`
  display: grid;
  grid-area: 2 / 2 / 3 / 3;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  ${breakpoints.to.tablet} {
    grid-template-columns: 1fr;
    gap: 0;
  }
  ${breakpoints.to.desktop} {
    grid-area: 3 / 1 / 4 / 2;
  }
  ${breakpoints.only.tablet} {
    grid-area: 4 / 1 / 4 / 2;
  }
`;
